export default __webpack_public_path__ + "static/media/card2@3x.883edfba.png";